import { ContentCreatorNotification } from 'common/src/api/contentFrontendVsContentBackend/types'
import produce from 'immer'

export const markAsSeen = produce(
    (state: ContentCreatorNotification[]): void => {
        state.forEach((notification) => {
            if (!notification.hasBeenSeen) {
                notification.hasBeenSeen = true
            }
        })
    }
)
